module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAs0lEQVQoU2NkwAO8J77Q+f//dzczM2sWIy51EEW/9oHkWZgZDLAqRFbEwMzovC1X9jKGQmyKQKaiKMSlCEUhPkVwhYQUgRW6zHzHz/b9y22wM5gZnUAOxxYSjJZ9jzkFmRjOMzD8l2NgYPbfViC9G6tCkKB7/2tJZsYf+/EphvvatfORFCs74z5cilGCB59ijADHpRhrFGJTjDNRoCj+y4Q9UcCCx3XyIymWf4wVf3+xtgAATbFqh5r3238AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/return.png
// module id = crFt
// module chunks = 1